const state = {
  oldSearchKey: ''
}

const getters = {

}

const mutations = {
  setOldSearchKey (state, value) {
    state.oldSearchKey = value
  }
}

const actions = {
  search ({ rootState, dispatch }, params) {
    return rootState.axios.get('/jyb/v1frontend/search/search', { params }).then(async (res) => {
      if (res.data.name === 'jyorder-index') {
        res.data.list = await dispatch('jyo/jyorder/formatOrder', res.data.list, {
          root: true
        })
      }
      return res
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
